import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import theme from 'ui/theme';
import MainFont from 'ui/typography/mainFont';

import { VipCardContainer } from './style';

const VipCard = ({ margin }) => {
  const { t } = useTranslation();

  return (
    <VipCardContainer margin={margin}>
      <MainFont type="button" configuration={{ color: theme().colors.white }}>
        {t('main.vip')}
      </MainFont>
    </VipCardContainer>
  );
};

VipCard.defaultProps = {
  margin: ''
};

VipCard.propTypes = {
  margin: PropTypes.string
};

export default VipCard;
